import React, { useEffect, useState } from "react";
import axiosInstance from "../../axios";
import { Loading } from "../Other/Loading";

const StudentListData = () => {
  const [studentData, setStudentData] = useState();
  const [getFetchStatus, setGetFetchStatus] = useState(true);
  const fetch = () => {
    axiosInstance
      .get("/student/statistics")
      .then((res) => {
        setStudentData(res?.data?.data);
        setGetFetchStatus(false);
      })
      .catch((error) => {
        console.log(error);
        setGetFetchStatus(false);
      });
  };

  useEffect(() => {
    fetch();
  }, []);
  return (
    <div className="flex-dashboard-new studentDashboardEnrolled">
      <div className="box-shadow-05 Dashboard-color-one">
        <p className="font-custom-p">Enrolled Courses</p>
        <p className={`font-increase color-one`}>
          {studentData?.enrolledCourse}
        </p>
        {getFetchStatus && (
          <div className="admindata-loading">
            <Loading />
          </div>
        )}

        <div className="dashboard-main-new">
          <p className="this-month-style">This month</p>
          <p className={` color-one flex-text-one`}>
            {studentData?.thisMonthEnrolledCourse}
          </p>
        </div>
      </div>

      <div className={`box-shadow-05 Dashboard-color-two`}>
        <p className="font-custom-p">Compeleted Webinars</p>
        <p className={`font-increase color-two`}>
          {studentData?.completedWebinars}
        </p>
        {getFetchStatus && (
          <div className="admindata-loading">
            <Loading />
          </div>
        )}

        <div className="dashboard-main-new">
          <p className="this-month-style">This month</p>
          <p className={` color-two flex-text-one`}>
            {studentData?.thisMonthCompletedWebinars}
          </p>
        </div>
      </div>
      <div className={`box-shadow-05 Dashboard-color-three`}>
        <p className="font-custom-p">Forum Question</p>
        <p className={`font-increase color-three`}>
          {studentData?.forumQuestions}
        </p>

        {getFetchStatus && (
          <div className="admindata-loading">
            <Loading />
          </div>
        )}

        <div className="dashboard-main-new">
          <p className="this-month-style">This Month</p>
          <p className={` color-three flex-text-one`}>
            {studentData?.thisMonthForumQuestions}
          </p>
        </div>
      </div>
      <div className={`box-shadow-05 Dashboard-color-four`}>
        <p className="font-custom-p">Certficates</p>
        <p className={`font-increase color-four`}>
          {studentData?.certificates}{" "}
        </p>

        {getFetchStatus && (
          <div className="admindata-loading">
            <Loading />
          </div>
        )}

        <div className="dashboard-main-new">
          <p className="this-month-style">This Month</p>
          <p className={` color-four flex-text-one`}>
            {studentData?.thisMonthCertificates}
          </p>
        </div>
      </div>
    </div>
  );
};

export default StudentListData;
